<template>
  <div class="order-wrapper payment-wrapper payment_table"
    :class="{ 'slide-active': isOpenSummary }">
    <div v-if="isUploading" class="paymentloader"></div>
    <FreightBillTable
      :isDedicatedTruck="isDedicatedTruck"
      :editable="!makeNonEditable"
      :depotWiseDetails="depotWiseDetails"
      :indentsCount="indentsCount"
      :isOpenSummary="isOpenSummary"
      :isFreightBill="!!freightBillId"
      :freightBillDetails="freightBillDetails"
      :indentDetails="indentDetails"
      :extraKmCharge="extraKmCharge"
      :initialExtraKmCharge="initialExtraKmCharge"
      @openSliderRight="openSliderRight"
      @openSummary="openSummary"
      @selectedIndentsUpdate="selectedIndentsUpdate"
      @loadMore="loadDepotWiseIndentDetails"
      @onUpload="onUpload"
      @save="save"/>
    <div class="slideright_drawer top_slideright" :class="{ openSlideright: isOpenSummary, extendSlider : extendSlider }">
      <div class="slideright_content">
        <div class="slideright_menu">
          <SummarySlide
            v-if="paymentsCount"
            :isDedicatedTruck="isDedicatedTruck"
            :indentExtraKm="getIndentExtraKm"
            :indentDetails="indentDetails"
            :currentClientGstType="currentClientGstType"
            :editable="true"
            :defaultIgst="defaultIgst"
            :defaultGstDetails="defaultGstDetails"
            :isTaxable="isTaxable"
            :paymentIds="ids"
            :isFreightBill="!!freightBillId"
            :freightBillId="freightBillId"
            :freightBillDetails="freightBillDetails"
            :attachmentsTransactionId="attachmentsTransactionId"
            @updateExtraKm="updateExtraKm"
            @extendSlider="extendSlider = $event"
            @close="closeSummary" />
        </div>
      </div>
    </div>
    <Dialog
      :visible="isRejected"
      width="350px"
      center class="centerdialogblock infodialog topmargin_n closenone">
      <div class="centerbtn">
        <h4><span class="sucess">{{this.uploadResponse.valid_count}}</span> Indents Uploaded</h4>
        <p>Download Rejections</p>
        <button class="btn section_ebtn" @click="downloadRejection">
          {{this.uploadResponse.invalid_count}} INDENTS</button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Messages } from '@/constants/messages';
import SummarySlide from '../../pay-v2/summary/SummarySlide';
import FreightBillTable from '../../pay-v2/details/FreightBillTable';
import { ChargesBy } from 'pando-constants';
import { v4 as uuid } from 'uuid';

export default {
  components: {
    SummarySlide,
    FreightBillTable,
  },
  data() {
    return {
      noRecords: false,
      isOpenSummary: false,
      isOpenSlideright: false,
      ids: null,
      validIds: [],
      timerTask: 6000,
      makeNonEditable: false,
      extraKmCharge: 0,
      freightBillId: null,
      uploaded: false,
      attachmentsTransactionId: uuid(),
      extendSlider: false,
    };
  },
  watch: {
    uploaded(to, from) {
      this.$router.go(0);
    },
  },
  mounted() {
    this.$store.commit('paymentsV2/initialReset');
    if (this.$route.query.freightBillId) {
      this.freightBillId = this.$route.query.freightBillId;
    } else if (this.$route.query.ids) {
      this.ids = this.$route.query.ids;
    }
    this.loadFreightBillDetails();
  },
  beforeDestroy() {
    this.$store.commit('paymentsV2/clearDepotDetails', {});
  },
  computed: {
    ...mapGetters({
      indentDetails: 'paymentsV2/indentDetails',
      dedicatedTruckMaster: 'paymentsV2/dedicatedTruckMaster',
      currentClient: 'app/currentClient',
      currentTransporter: 'app/currentTransporter',
      isLoading: 'paymentsV2/isLoading',
      filter: 'paymentsV2/filter',
      hasEmpty: 'paymentsV2/hasEmpty',
      isUploading: 'paymentsV2/isUploading',
      isRejected: 'paymentsV2/isRejected',
      uploadResponse: 'paymentsV2/uploadResponse',
      systemTotal: 'paymentsV2/totalSystemCharges',
      transporterTotal: 'paymentsV2/totalTransporterCharges',
      configurations: 'app/currentClientConfig',
      freightBillDetails: 'paymentsV2/freightBillDetails',
      totalIndentCount: 'paymentsV2/totalIndentCount',
      depotWiseDetails: 'paymentsV2/depotWiseDetails',
      selectedPaymentsList: 'paymentsV2/selectedPaymentsList',
    }),
    indentsCount() {
      return this.totalIndentCount;
    },
    paymentsCount() {
      return this.indentDetails.length > 0 || this.totalIndentCount > 0;
    },
    getCurrentDepotState() {
      return (this.indentDetails && this.indentDetails[0]) && this.indentDetails[0].depot.state;
    },
    currentClientGst() {
      if (this.currentTransporter && this.currentClient) {
        return this.currentTransporter.gst_details.find(
          gst => gst.client_id === this.currentClient.id,
        );
      }
      return undefined;
    },
    currentClientGstType() {
      return (this.currentClientGst && this.currentClientGst.type);
    },
    defaultIgst() {
      return (this.currentClientGst && this.currentClientGst.percentage) || 0;
    },
    defaultGstDetails() {
      if (this.currentTransporter.gst_number && this.currentTransporter.gst_number.length) {
        const gstNumbersList = this.currentTransporter.gst_number.map(gst => Object.assign({
          name: gst.state,
          number: gst.number,
          ack_no: gst.ack_no,
          ack_date: gst.ack_date,
          gst_type: gst.gst_type,
          percentage: gst.percentage,
        }));
        return (gstNumbersList.length === 1) ? gstNumbersList[0] : {};
      }
      return {};
    },
    isTaxable() {
      const [firstElement] = this.indentDetails;
      return firstElement && firstElement.taxable;
    },
    isDedicatedTruck() {
      // Check type DEDICATED_TRUCK_WITH_INDENT_PAYMENT
      return !!(this.dedicatedTruckMaster);
    },
    initialExtraKmCharge() {
      const extraKm = this.getIndentExtraKm;
      const bfrPerKmRate = (this.dedicatedTruckMaster && this.dedicatedTruckMaster.bfr_per_km_rate) || 0;
      const perKmRate = (this.dedicatedTruckMaster && this.dedicatedTruckMaster.per_km_rate) || 0;
      const amount = extraKm * (perKmRate + bfrPerKmRate);
      return Number((amount / this.indentDetails.length).toFixed(2));
    },
    getIndentExtraKm() {
      const minimumGuaranteeKm = (this.dedicatedTruckMaster && this.dedicatedTruckMaster.guarantee_km) || 0;
      const distance = this.indentDetails.reduce((acc, indent) => acc + (Number(indent.indent_distance) || 0), 0);
      const extraKm = (distance - minimumGuaranteeKm);
      return ((extraKm > 0) ? Number(extraKm.toFixed(2)) : 0);
    },
  },
  methods: {
    async loadFreightBillDetails() {
      if (this.freightBillId) {
        await this.$store.dispatch('paymentsV2/getFreightBillDetails', {
          freightBillId: this.freightBillId,
        });
      } else if (this.ids) {
        await this.$store.dispatch('paymentsV2/getFreightBillDetails', {
          paymentIds: this.ids,
        });
      }
    },

    async loadDepotWiseIndentDetails($state, depot) {
      try {
        let currentDepot = this.depotWiseDetails && this.depotWiseDetails[depot];
        if (currentDepot) {
          let result;
          if (this.freightBillId) {
            const params = Object.assign({ page_number: currentDepot.page_number, page_limit: 25, depot_id: depot });
            const data =
                { params, freightBillId: this.freightBillId };
            result = await this.$store.dispatch('paymentsV2/getDepotWiseIndentCharges', data);
          } else if (this.ids) {
            const params = Object.assign(
              { page_number: currentDepot.page_number, page_limit: 25, depot_id: depot });
            // Below condition is added to handle multiple payments_id passed to backend
            // which leads to incorrect sql query response
            if (params.page_number === 1) {
              const paymentIds = this.ids.trim().split(',');
              const sortedPaymentIds = paymentIds.sort();
              this.$store.commit('paymentsV2/setSelectedPaymentsList', sortedPaymentIds);
            }
            const first_25 = this.selectedPaymentsList.splice(0, 25);
            this.$store.commit('paymentsV2/setSelectedPaymentsList', this.selectedPaymentsList);
            if (first_25 && first_25.length) {
              params.payment_ids = first_25.join(',');
              const data = { params };
              result = await this.$store.dispatch('paymentsV2/getIndentCharges', data);
            } else {
              $state.complete();
            }
            if(this.isDedicatedTruck) {
              let first_25 = this.selectedPaymentsList.splice(0, 25);
              params.page_number = 2;
              while(first_25.length) {
                this.$store.commit('paymentsV2/setSelectedPaymentsList', this.selectedPaymentsList);
                if (first_25 && first_25.length) {
                  params.payment_ids = first_25.join(',');
                  const data = { params };
                  result = await this.$store.dispatch('paymentsV2/getIndentCharges', data);
                  params.page_number += 1;
                  first_25 = this.selectedPaymentsList.splice(0, 25);
                } else {
                  $state.complete();
                }
              }
            }
          } else {
            $state.complete();
          }
          if (result && result.paymentDetails && result.paymentDetails.isNotCombinable) {
            this.$errorMessage({ message: Messages.SOMETHING_WENT_WRONG_WHILE_UPLOAD });
            $state.complete();
          }
          if (result && result.error) {
            this.$errorMessage({ message: result.error });
            $state.complete();
          }
          currentDepot = this.depotWiseDetails && this.depotWiseDetails[depot];
          if ($state) {
            if (currentDepot.has_empty) {
              $state.complete();
            } else {
              $state.loaded();
            }
          }
        } else {
          // $state.complete();
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
        $state.complete();
      }
    },
    openSummary() {
      this.isOpenSummary = true;
      setTimeout(() => {
        this.makeNonEditable = true;
      }, 500);
    },
    closeSummary() {
      this.isOpenSummary = false;
      setTimeout(() => {
        this.makeNonEditable = false;
      }, 500);
    },
    openSliderRight(value) {
      this.isOpenSlideright = value;
    },
    async onUploadRedirect(validIds, callLoader = false) {
      let tempIds = validIds;
      if (this.ids) {
        tempIds = [...this.ids.split(','), ...validIds.map(String)];
      }
      const tempIdsSet = [...new Set(tempIds)];
      const UpdatedIds = tempIdsSet.join(',');
      this.$store.commit('paymentsV2/setPage', 1);
      if (callLoader) {
        await this.loadDepotWiseIndentDetails();
      }
      this.$router.push({ name: 'IndentDetails', query: { ids: UpdatedIds } });
      this.uploaded = !this.uploaded;
    },
    selectedIndentsUpdate(indentsIds) {
      const removedIndentDetailsTotal = this.indentDetails.filter(indent => indentsIds.includes(indent.id)).reduce((acc, indent) => {
        acc.system += indent.indent_total_system_charge;
        acc.transporter += indent.indent_total_charge;
        return acc;
      }, { system: 0, transporter: 0 });

      const updatedIndents = (this.indentDetails.filter(indent => !indentsIds.includes(indent.id)) || []);

      this.$store.commit('paymentsV2/replaceIndentDetails', updatedIndents);
      this.$store.commit('paymentsV2/setTotalSystemCharges', this.systemTotal - removedIndentDetailsTotal.system);
      this.$store.commit('paymentsV2/setTotalTransporterCharges', this.transporterTotal - removedIndentDetailsTotal.transporter);
      const updatedIds = this.$route.query.ids.split(',').filter(val => !indentsIds.includes(parseInt(val)));
      if (!updatedIndents.length) {
        this.$router.push({ name: 'IndentDetails' });
        this.ids = '';
      } else {
        this.$router.push({ name: 'IndentDetails', query: { ids: updatedIds.join(',') } });
        this.ids = updatedIds.join(',');
      }
    },

    constructUpdateChargesPayload() {
      const resultArray = [];
      Object.keys(this.tempChargeList).forEach((consigneeId) => {
        const currentConsigneeCharges = this.tempChargeList[consigneeId];
        const currentIndentId = currentConsigneeCharges.paymentId;
        delete currentConsigneeCharges.paymentId;
        const obj = Object.assign({ id: consigneeId, charges: currentConsigneeCharges });
        const indentIndex = resultArray.findIndex(indent => indent.id === currentIndentId);
        if (indentIndex >= 0) {
          resultArray[indentIndex].consignee_data.push(obj);
        } else {
          const consignee_data = [];
          consignee_data.push(obj);
          const dummyObj = { id: currentIndentId, consignee_data };
          resultArray.push(dummyObj);
        }
      });
      return resultArray;
    },

    updateIndentCharges(result, payments, requestedTotal) {
      const details = this.indentDetails;
      this.errorArray = [];
      payments.forEach((payment) => {
        const paymentResult = result.find(val => val.id === payment.id);
        if (paymentResult && paymentResult.status === 200) {
          const detail = details.find(val => val.id === payment.id);
          if (detail) {
            detail.consignee_data.forEach((consignee, index) => {
              if (consignee.charges) {
                const chargeIndex = consignee.charges.findIndex(val => val.charges_by === ChargesBy.TRANSPORTER);
                const consigneeUpdatedCharges = this.tempChargeList[consignee.id];
                const oldValues = detail.consignee_data[index].charges[0];
                detail.consignee_data[index].charges[0] = Object.assign(oldValues, consigneeUpdatedCharges);
              }
            });
          }
        } else {
          this.errorArray.push(payment.id);
        }
      });
      this.$store.commit('paymentsV2/replaceIndentDetails', details);
      this.$store.commit('paymentsV2/setTotalTransporterCharges', requestedTotal);
      return true;
    },

    async save(requestedTotal) {
      try {
        const paymentsPayload = this.constructUpdateChargesPayload();
        while (paymentsPayload.length) {
          const payments = paymentsPayload.splice(0, 10);
          const result = await this.$store.dispatch('paymentsV2/updateMultiPayments', { payments });
          if (result && result.error) {
            this.$errorMessage({ message: result.error });
            return;
          } else if (result.data === 'Success') {
            await this.updateIndentCharges(result.updates, payments, requestedTotal);
            this.$successMessage({ message: this.$getSuccess('UPDATE_SUCCESS') });
            this.$store.commit('paymentsV2/setTempCharges', {});
          }
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('UPDATE_FAILURE') });
      }
    },

    async onUpload(file) {
      try {
        if (file) {
          this.timerTask = 1000;
          const formData = new FormData();
          formData.append('attachment', file);
          const result = await this.$store.dispatch('paymentsV2/uploadExcel', formData);
          if (result && result.data === 'Success') {
            this.$store.commit('paymentsV2/setUploading', true);
            this.$successMessage({ message: Messages.UPLOAD_SUCCESS });
            const timer = setInterval(() => {
              if (!this.timerTask) {
                clearInterval(timer);
              } else {
                this.uploadStatus(result.key);
              }
            }, this.timerTask);
          } else if (result && result.data && result.data.errors
        && result.data.errors[0] && result.data.errors[0].code === 'ERR_RECORD_LIMIT_EXCEEDED') {
            this.$errorMessage({ message: `Maximum number of trips allowed per upload = ${this.configurations.payment_settings.limit_trip_upload}` });
          } else if (result.status === 400 && result.data.errors[0].code === 'ERR_INVALID_FILE_HEADERS') {
            const error = `Missing fields - ${result.data.errors[0].data.join(',')}`;
            this.$errorMessage({ message: error, header: 'Error in Uploading' });
          }
        } else {
          this.$errorMessage({ message: Messages.NO_FILE });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    async uploadStatus(data) {
      const result = await this.$store.dispatch('paymentsV2/uploadStatus', {
        key: data,
      });
      console.log(result);
      if (result.code === 'COMPLETED') {
        this.$store.commit('paymentsV2/setUploading', false);
        this.timerTask = 0;
        this.$store.commit('paymentsV2/setUploadResponse', result);
        if (result.invalid_count > 0) {
          this.$store.commit('paymentsV2/setRejected', true);
        } else {
          this.$successMessage({
            message: 'All records are uploaded successfully',
          });
          this.onUploadRedirect(this.uploadResponse.validIds);
        }
      } else if (result.code === 'FAILED') {
        this.$store.commit('paymentsV2/setUploading', false);
        this.timerTask = 0;
        if (result.error) {
          this.$errorMessage({
            message: result.error,
          });
        } else {
          this.$errorMessage({
            message: 'Upload Failed',
          });
        }
      }
    },
    downloadRejection() {
      this.downloadRejectedFile();
      setTimeout(() => {
        this.onUploadRedirect(this.uploadResponse.validIds);
      }, 1000);
    },
    downloadRejectedFile() {
      this.$store.commit('paymentsV2/setRejected', false);
      const link = document.createElement('a');
      link.href = this.uploadResponse.rejectedFilePath;
      link.setAttribute('download', 'rejectedIndents.xlsx');
      document.body.appendChild(link);
      link.click();
    },
    updateExtraKm(extraKm) {
      const bfrPerKmRate = this.dedicatedTruckMaster.bfr_per_km_rate || 0;
      const totalExtraKmCharge = extraKm * (this.dedicatedTruckMaster.per_km_rate + bfrPerKmRate);
      this.extraKmCharge = (totalExtraKmCharge / this.indentDetails.length).toFixed(2);
      let tempIndents = this.indentDetails;
      let transporterTotal = 0;
      if (Number(this.extraKmCharge) || Number(this.extraKmCharge) === 0) {
        tempIndents = tempIndents.map((indent) => {
          const indentTemp = indent;
          indentTemp.consignee_data =
            indentTemp.consignee_data && indentTemp.consignee_data.map((consignee) => {
              const consigneeTemp = consignee;
              consigneeTemp.charges =
                consigneeTemp.charges && consigneeTemp.charges.map((charge) => {
                  const chargeTemp = charge;
                  if (chargeTemp.charges_by === ChargesBy.TRANSPORTER) {
                    const initialExtraKmCharge = chargeTemp.extra_km_charge;
                    const extraCharge = this.extraKmCharge - initialExtraKmCharge;
                    const total = (chargeTemp.total_amount + extraCharge).toFixed(2);
                    chargeTemp.total_amount = Number(total);
                    chargeTemp.extra_km_charge = Number(this.extraKmCharge);
                    transporterTotal += chargeTemp.total_amount;
                  }
                  return chargeTemp;
                });
              return consigneeTemp;
            });
          return indentTemp;
        });
        this.$store.commit('paymentsV2/setTotalTransporterCharges', (transporterTotal));
      }
      this.$store.commit('paymentsV2/replaceIndentDetails', tempIndents);
    },
  },
};
</script>
